var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7937 10.9512L20.224 7.63649V2.20612H16.1119V3.81845L11.9999 0L0.206511 10.9512C0.0403836 11.1058 0.0305147 11.3661 0.185128 11.5327C0.33933 11.6988 0.599623 11.7082 0.766572 11.554L2.13136 10.2867V24H8.71065H15.2899H21.8692V10.2863L23.234 11.5536C23.313 11.6272 23.4137 11.6634 23.514 11.6634C23.6247 11.6634 23.7344 11.6194 23.815 11.5323C23.9697 11.3661 23.9598 11.1058 23.7937 10.9512ZM16.9343 3.02853H19.4016V6.87289L16.9343 4.58206V3.02853ZM9.53265 23.1776V14.5164C9.53265 14.3038 9.70535 14.1311 9.91795 14.1311H14.0818C14.2944 14.1311 14.4671 14.3038 14.4671 14.5164V23.1776H9.53265ZM21.0464 23.1776H15.2895V14.5164C15.2895 13.8502 14.748 13.3087 14.0818 13.3087H9.91795C9.25179 13.3087 8.71024 13.8502 8.71024 14.5164V23.1776H2.95336V9.52269L11.9999 1.12218L17.8719 6.57476L20.224 8.75867L21.0464 9.52228V23.1776Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.98a5d487.svg";
export { ForwardRef as ReactComponent };